import React, { Component, ErrorInfo, ReactNode } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null,
    };

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center min-h-[400px] p-6 text-center">
                    <div className="bg-red-50 p-4 rounded-full mb-4">
                        <AlertTriangle className="h-10 w-10 text-red-500" />
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">حدث خطأ ما</h2>
                    <p className="text-gray-600 mb-6 max-w-md">
                        نعتذر، حدث خطأ غير متوقع أثناء تحميل هذه الصفحة.
                    </p>
                    {this.state.error && (
                        <pre className="bg-gray-100 p-4 rounded-md text-left text-xs text-red-600 mb-6 overflow-auto max-w-full">
                            {this.state.error.toString()}
                        </pre>
                    )}
                    <Button
                        onClick={() => window.location.reload()}
                        variant="outline"
                    >
                        إعادة تحميل الصفحة
                    </Button>
                </div>
            );
        }

        return this.props.children;
    }
}
